module.exports = __webpack_public_path__ + "fonts/iconfont.72edc67b.woff2";